import React, { useEffect, useState } from "react";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import "./LandingScreen.css";
import Navbar from "../../components/Navbar/Navbar";

/**Firebase Imports**/
import { selectUser, useSelector } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
import { query, collection, getDocs, db } from "../../firebaseConfig";
/** **/

const LandingScreen = () => {
	const navigate = useNavigate();
	const { user } = useSelector(selectUser);
	const [extraLinks, setExtraLinks] = useState([]);

	useEffect(() => {
		const getLinks = async () => {
			const tempArr = [];
			const querySnapshot = await getDocs(query(collection(db, "links")));
			querySnapshot.forEach((doc) => {
				tempArr.push({
					URL: doc.data().URL,
					description: doc.data().description,
					heading: doc.data().heading.toUpperCase(),
				});
			});
			setExtraLinks(tempArr);
		};
		getLinks();
	}, [user, navigate]);
	/** **/

	/**
	 * Main Functions
	 * **/

	/** **/

	return (
		<div className="LandingScreen h-full w-full overflow-y-auto m-0 p-0">
			<div className="h-full w-full  m-0 p-3 py-8 flex flex-col">
				<Navbar backTarget={"/"} />
				<Header className={"my-8"} size={"medium"}>
					Welcome, {user.name === "" || user.name === null ? "_" : user.name}
				</Header>
				<Button
					className={"my-2 font-bold mx-auto"}
					title={"FIXED COST"}
					mode={"filled"}
					size={"full"}
					onClick={(e) => {
						navigate("/fixedcost");
					}}
				/>
				<Button
					className={"my-2 font-bold mx-auto"}
					title={"VARIABLE COST"}
					mode={"filled"}
					size={"full"}
					onClick={(e) => {
						navigate("/variablecost");
					}}
				/>
				<Button
					className={"my-2 font-bold mx-auto"}
					title={"WEEKLY COST CALCULATION"}
					mode={"filled"}
					size={"full"}
					onClick={(e) => {
						navigate("/weeklycost");
					}}
				/>

				{extraLinks.map(({ heading, URL, description }, index) => (
					<Button
						key={index}
						className={"my-2 font-bold mx-auto"}
						title={heading}
						mode={"filled"}
						size={"full"}
						onClick={(e) => window.open(URL, "_blank")}
						description={description}
					/>
				))}
			</div>
		</div>
	);
};

export default LandingScreen;
